import React from "react";
import styles from "./Projects.module.css";
import { Link } from "react-router-dom";

export default function Projects() {
  /*  function lucid() {
    alert('This website is being developed, stay tuned for more updates. \n HAPPY CODING😊')
  } */

  return (
    <div id={styles.projectsPage}>
      <section id={styles.projectsList}>
        <div id={styles.current}>
          <h2>DEVELOPING </h2>
          <a href="#LucidClothing">
            <p>Lucid Clothing</p>
          </a>
        </div>

        <div id={styles.projectHeadings}>
          <h2>PROJECTS</h2>

          <ul>
            <a href="#calculator">
              <li>Calculator</li>
            </a>
            <a href="#cinemate">
              <li>Cinemate</li>
            </a>
            <a href="#cube">
              <li>Cube-CSS</li>
            </a>
            <a href="#dictionary">
              <li>Dictionary</li>
            </a>
            <a href="#githubAPI">
              <li>GitHub REST API</li>
            </a>
            {/* <a href="#portfolio">
              <li>My Old Portfolio</li>
            </a>
            <a href="#teaCozy">
              <li>Tea Cozy</li>
            </a> */}

            {/* <a href='#tick'><li>Tick Tac Toe</li></a> */}
          </ul>
        </div>
      </section>

      <section id={styles.projectsSection}>
        <div className={styles.project} id="LucidClothing">
          <h5>LUCID CLOTHING</h5>

          <div className={styles.projectContainer}>
            <div className={styles.ProjectImg}>
              <img
                src="./lucidClothing.png"
                alt="Lucid Clothing mobile landing page"
              />
              {/* <!-- <p >Click, to learn more about the project</p> --> */}
            </div>
            <div className={styles.info}>
              <p className={styles.description}>
                Lucid Clothing is an ecommerce store specializing in the latest
                trending shoes, clothes, and accessories, catering to a wide
                range of styles. This project serves as a platform for
                showcasing my expertise while also providing exposure to diverse
                learning opportunities in various coding scenarios. It aims to
                expand my knowledge and proficiency in React, while also
                refining my skills in replicating existing designs within my own
                work. The UX/UI design takes inspiration from various websites
                such as Pretty Little Thing, John Lewis, House of Fraser,
                Boohoo, and ASDA George. Despite their distinctiveness,
                analyzing the commonalities and differences among these sites
                provides valuable insights into what resonates most effectively
                with their respective audiences.
              </p>

              <div className={styles.stackLabels}>
                <p>React.js</p>
                <p>TypeScript</p>
                <p>CSS</p>
              </div>

              <div className={styles.buttons}>
                <Link to="https://lucidclothing.onrender.com/" target="_self">
                  <button className={styles.live}>Live</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div id="cube" className={styles.project}>
          <h5>CUBE - CSS Project</h5>

          <div className={styles.projectContainer}>
            <div className={styles.ProjectImg}>
              <img src="./dice.png" alt="Dice project" />
            </div>

            <div>
              <p className={styles.description}>
                I created this to learn more about the animation and transform
                CSS properties. One of the things that got me into developing my
                design skill was the concept of CSS art. I came across a few
                developers who created art through code, I was blown away by the
                level of detail that was put into the work and the possibility
                of that level of working being produced through code. It
                inspired me to want to become better in my CSS and UX/UI skills.
              </p>

              <br />

              <p className={styles.description}>
                I initially created the colorful cube and implemented a
                numbering system to ensure all sides were in place. Once this
                cube was complete, I explored a few designs and decided to go
                with a die style.
              </p>

              <div className={styles.stackLabels}>
                <p>HTML</p>
                <p>CSS</p>
              </div>

              <div className={styles.buttons}>
                <Link to="https://cube-css.onrender.com/" target="_self">
                  <button className={styles.live}>Live</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div id="calculator" className={styles.project}>
          <h5>CALCULATOR</h5>

          <div className={styles.projectContainer}>
            <div className={styles.ProjectImg}>
              <img src="./calculator.png" alt="Calculator project" />
            </div>

            <div>
              <p className={styles.description}>
                I created this to refresh my mind on the basic concepts used in
                React. It had been a while since I used the framework, so I
                developed this small, simple project to prepare me for the
                current project I'm building.
              </p>

              <p className={styles.description}>
                Functionality: addition, subtraction, multiplication, and
                division
              </p>

              <div className={styles.stackLabels}>
                <p>React</p>
                <p>CSS</p>
              </div>

              <div className={styles.buttons}>
                <a href="https://tk-calculatorapp.onrender.com/" target="_self">
                  <button className={styles.live}>Live</button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div id="dictionary" className={styles.project}>
          <h5>DICTIONARY APP</h5>

          <div className={styles.projectContainer}>
            <div className={styles.ProjectImg}>
              <img src="./dictionary.png" alt="Dictionary api project" />
            </div>

            <div>
              <p className={styles.description}>
                Dictionary App is a responsive web app designed to allow users
                search for any words they desire to understand. The app was
                created by using 4 different api in order to render different
                details about a particular word that the user has researched
              </p>

              <div className={styles.stackLabels}>
                <p>HTML</p>
                <p>CSS</p>
                <p>Javascript</p>
                <p>Nodejs</p>
                <p>Playwright</p>
              </div>

              <div className={styles.buttons}>
                <a href="https://dictionary-zc7r.onrender.com/" target="_self">
                  <button className={styles.live}>Live</button>
                </a>
                <a
                  href="https://github.com/Tendaik96/Dictionary"
                  target="_self"
                >
                  <button className={styles.code}>Code</button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div id="cinemate" className={styles.project}>
          <h5>
            CINEMATE <br /> <em>(School of code group project)</em>
          </h5>

          <div className={styles.projectContainer}>
            <div className={styles.ProjectImg}>
              <img src="./cinemate.png" alt="Cinemate" />
              {/* <!-- <p >Click, to learn more about the project</p> --> */}
            </div>
            <div>
              <p className={styles.description}>
                Cinemate helps movie enthusiasts remember movie recommendations
                from friends and family, making it easier for them to plan their
                movie nights. The app is responsive and accessible across all
                devices, enabling users to manage their movie recommendations
                on-the-go.
              </p>

              <div className={styles.stackLabels}>
                <p>Tailwind</p>
                <p>Next.js</p>
                <p>Supabase</p>
                <p>Typescript</p>
                <p>Jest</p>
              </div>

              <div className={styles.buttons}>
                <Link to="https://project-cinemate.netlify.app" target="_self">
                  <button className={styles.live}>Live</button>
                </Link>
                <Link
                  to="https://github.com/bennyfreemantle/404-team-name-not-found"
                  target="_self"
                >
                  <button className={styles.code}>Code</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* <div id="portfolio" className={styles.project}>
          <h5>MY OLD PORTFOLIO</h5>

          <div className={styles.projectContainer}>
            <div className={styles.ProjectImg}>
              <img src="./oldPortfolio.png" alt="my portfolio landing page" />
            </div>
            <div>
              <p className={styles.description}>
                {" "}
                This is my old portfolio. I never published this project because
                I was still working on some personal projects. Also, I wasn't
                too keen on the design initially; I liked it at first, but then
                decided to hold back until I thought of a better design. This
                website is what I came up with.
              </p>

              <div className={styles.stackLabels}>
                <p>HTML</p>
                <p>CSS</p>
                <p>Javascript</p>
              </div>

              <div className={styles.buttons}>
                <a href="https://tendaikaruwo.onrender.com/" target="_self">
                  <button className={styles.live}>Live</button>
                </a>

                <a
                  href="https://github.com/Tendaik96/MyPortfolio"
                  target="_self"
                >
                  <button className={styles.code}>Code</button>
                </a>
              </div>
            </div>
          </div>
        </div> */}

        <div id="githubAPI" className={styles.project}>
          <h5>GitHub REST API</h5>

          <div className={styles.projectContainer}>
            <div>
              <p className={styles.description}>
                I created a Node.js service that utilizes GitHub APIs to allow
                the client to query GitHub repositories by name, ID and request
                ReadMe file (if available).
              </p>

              <div className={styles.stackLabels}>
                <p>Node.js</p>
                <p>Node Typescript (node-ts)</p>
                <p>Jest (ts)</p>
              </div>

              <div className={styles.buttons}>
                <a
                  href="https://github.com/Tendaik96/GitHub-REST-API"
                  target="_self"
                >
                  <button className={styles.code}>Code</button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div id="githubAPI" className={styles.project}>
          <div className={styles.projectContainer}>
            <div>
              <em>
                <p className={styles.description}>
                  Want to see more? I've built plenty beyond what's shown
                  here—just reach out and I'll happily share additional
                  projects.
                </p>
              </em>
            </div>
          </div>
        </div>

        {/* <div id="teaCozy" className={styles.project}>
          <h5>TEA COZY</h5>
          <div>
            <div>
              <p className={styles.description}>
                {" "}
                Tea Cozy is a project I did as part of the codecademy css course
                I completed. I created a fictional tea shop website, Codecademy
                provided a design spec and image assets to help me complete the
                project. Note: This project is not responsive.
              </p>

              <div className={styles.stackLabels}>
                <p>HTML</p>
                <p>CSS</p>
              </div>

              <div className={styles.buttons}>
                <a href="https://teacozytk.netlify.app/" target="_self">
                  <button className={styles.live}>Live</button>
                </a>
                <a
                  href="https://github.com/Tendaik96/TeaCozy/tree/main"
                  target="_self"
                >
                  <button className={styles.code}>Code</button>
                </a>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </div>
  );
}
